import { useState } from "react"
import { useGlobalAlert } from "contexts/GlobalAlertContext"
import { studentRequest } from "services/requests"

const prefix = "realTimeInstruction"

const useApi = () => {
  const [isFetching, setIsFetching] = useState(false)
  const { showAlert } = useGlobalAlert()

  const addTeam = async ({ groupId, gameId }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `${prefix}/addTeam?groupId=${groupId}&gameId=${gameId}`,
      body: null,
      method: "post",
    })
    setIsFetching(false)
    return response
  }

  const setTeamActive = async ({ groupId, gameId, teamId }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `${prefix}/setTeamActive?groupId=${groupId}&gameId=${gameId}&teamId=${teamId}`,
      body: null,
      method: "post",
    })
    setIsFetching(false)
    return response
  }

  const getTeamMembers = async ({ groupId, gameId }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `${prefix}/teamMembers?groupId=${groupId}&gameId=${gameId}`,
      body: null,
      method: "get",
    })
    setIsFetching(false)
    if (!response.success) {
      showAlert(response.message)
      return []
    }
    return response?.data?.teamMembers || []
  }

  const addTeamMember = async ({ groupId, gameId, teamId, userId }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `${prefix}/addTeamMember?groupId=${groupId}&gameId=${gameId}&teamId=${teamId}&userId=${userId}`,
      body: null,
      method: "post",
    })
    setIsFetching(false)
    return response?.data || { status: false }
  }

  const removeTeamMember = async ({ groupId, gameId, teamId, userId }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `${prefix}/removeTeamMember?groupId=${groupId}&gameId=${gameId}&teamId=${teamId}&userId=${userId}`,
      body: null,
      method: "post",
    })
    setIsFetching(false)
    return response?.data || { status: false }
  }

  return {
    addTeam,
    setTeamActive,
    getTeamMembers,
    addTeamMember,
    removeTeamMember,
    isFetching,
  }
}

export default useApi
